
      <!--  POPOVER  -->

      <div class="popover"
           [class.show]="uiPopover.show"
           [class.has-arrow]="uiPopover.hasArrow"
           [ngClass]="['face-' + uiPopover.face, 'pos-' + uiPopover.position]"
           [style.right]="offset.right"
           [style.left]="offset.left"
           [style.top]="offset.top"
           [style.bottom]="offset.bottom">

          <!--  POPOVER INNER  -->

          <div class="inner"
               [style.min-width]="(uiPopover.minWidth) ? uiPopover.minWidth + 'px' : null"
               [style.max-width]="(uiPopover.maxWidth) ? uiPopover.maxWidth + 'px' : null"
               [style.min-height]="(uiPopover.minHeight) ? uiPopover.minHeight + 'px' : null"
               [style.max-height]="(uiPopover.maxHeight) ? uiPopover.maxHeight + 'px' : null">

              <!--  POPOVER CONTENT CONTAINER  -->

              <ng-content></ng-content>

              <!--  END POPOVER CONTENT CONTAINER  -->

          </div>

          <!--  END POPOVER INNER  -->

      </div>

      <!--  END POPOVER  -->
    